import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css']
})
export class PagenotfoundComponent {

  voices: any[]=[];
  selectedGender: string = '';
  selectedDisplayName: string = '';
  selectedStylist: string = '';

  displayDisplayNameDropdown: boolean = false;
  displayStylistDropdown: boolean = false;

  genders: string[] = ['Male', 'Female'];
  displayNames: string[] = [];
  stylists: string[] = [];

  constructor(private http: HttpClient) {
    this.http.get<any[]>('/assets/speechstyles.json').subscribe(data => {
      this.voices = data;
    });
  }

  onSelectGender() {
    this.displayDisplayNameDropdown = true;
    this.displayStylistDropdown = false;
    this.stylists = [];

    this.displayNames = this.voices
      .filter(voice => voice.Gender === this.selectedGender)
      .map(voice => voice.DisplayName);
  }

  onSelectDisplayName() {
    this.displayStylistDropdown = this.voices.some(voice => voice.DisplayName === this.selectedDisplayName);
    if (this.displayStylistDropdown) {
      const voice = this.voices.find(voice => voice.DisplayName === this.selectedDisplayName);
      console.log(voice,voice.StyleList)
      this.stylists = [];
      if (voice.StyleList) {
        this.stylists = voice.StyleList;
      }
      // ok
    }
  }

  onSubmit() {
    console.log('Selected Gender:', this.selectedGender);
    console.log('Selected Display Name:', this.selectedDisplayName);
    console.log('Selected Stylist:', this.selectedStylist);
  }
}
